import React from 'react';
import { paymentToString } from './CompositeProductEdit';
import { Button, Glyphicon } from 'react-bootstrap';
import CreatePaymentModal from './CreatePaymentModal';
import '../deals.less';
import { List } from 'immutable';

export default class DealPaymentsDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.openEdit = this.openEdit.bind(this);
    this.closeEdit = this.closeEdit.bind(this);
    this.getPaymentIdx = this.getPaymentIdx.bind(this);
    this.state = { showEditContractPayment: false };
  }
  getPaymentIdx() {
    return this.state.paymentIdx;
  }
  openEdit(paymentIdx) {
    this.setState({ showEditContractPayment: true, paymentIdx });
  }
  closeEdit() {
    this.setState({ showEditContractPayment: false, paymentIdx: undefined });
  }


  render() {
    return (<div>
      <CreatePaymentModal
        contractDate={this.props.contractDate}
        product={this.props.product}
        dealType={this.props.dealType}
        idx={this.props.productIdx}
        resolvePaymentIdx={this.getPaymentIdx}
        show={this.state.showEditContractPayment}
        closeModal={this.closeEdit}
        contractor={this.props.contractor}
      />
      <div className="payments-area">
        {this.props.customPayments && this.props.customPayments.map((p, idx) => <div>
          {idx + 1}.<Button
            bsStyle="link"
            style={{ padding: 0 }}
            disabled={p.get('approve')
            || p.get('payments', new List()).size > 0
            || p.get('paymentAmount')}
            onClick={() => this.openEdit(p.get('paymentIdx'))}
          >
            <Glyphicon glyph="edit" />
          </Button> {paymentToString(p, this.props.paymentMethods)}
        </div>)}
      </div>
    </div>);
  }
}

DealPaymentsDisplay.propTypes = {
  customPayments: React.PropTypes.object,
  paymentMethods: React.PropTypes.object,
  productIdx: React.PropTypes.number,
  dealType: React.PropTypes.string,
  product: React.PropTypes.object,
  contractor: React.PropTypes.number,
  contractDate: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.date]),
};
